import React from 'react';

import classes from './DetailsBlock.module.scss';
import { InfoBox } from '../../../../shared/components/ui-components';
import { HostInfo } from './HostInfo/HostInfo';
import { InfoSection } from './InfoSection/InfoSection';
import {
  ChallengeImportantDatesInfo,
  ChallengeHostInfo,
} from '../../../interfaces/ChallengeInfo';
import { getFormattedDateInTz } from '../../../../shared/utils/timezoneUtils/getFormattedDateInTz';
import { localDataFormat } from '../../../../shared/constants/apiDateFormat';
import { getTimezoneLabel } from '../../../../shared/utils/timezoneUtils/getTimezoneLabel';
import { getPriceOrDash } from '../../../../payment/utils/getPriceOrDash/getPriceOrDash';

type DetailsBlockProps = {
  price: number | null;
  importantDates: ChallengeImportantDatesInfo;
  host: ChallengeHostInfo;
};

const DetailsBlock = ({ price, importantDates, host }: DetailsBlockProps) => {
  return (
    <InfoBox title="Details" customContentPadding customMargin>
      <HostInfo hostName={host.entityName} avatarUrl={host.entityLogo?.fileUrl} />
      <InfoSection
        className={classes.priceSection}
        title="Price"
        description={getPriceOrDash(price)}
        helperText="plus sales tax (if applicable)"
      />
      <div className={classes.datesSection}>
        <InfoSection
          title="Challenge Starts"
          description={
            importantDates.startDate && importantDates.timeZone
              ? getFormattedDateInTz(
                  importantDates.startDate,
                  importantDates.timeZone,
                  localDataFormat,
                )
              : '-'
          }
        />
        <InfoSection
          title="Challenge Ends"
          description={
            importantDates.endDate && importantDates.timeZone
              ? getFormattedDateInTz(
                  importantDates.endDate,
                  importantDates.timeZone,
                  localDataFormat,
                )
              : '-'
          }
          className={classes.alignEnd}
        />
        <InfoSection
          title="Initial Scan Date Range"
          description={
            importantDates.firstScanStartDate &&
            importantDates.firstScanEndDate &&
            importantDates.timeZone
              ? `${getFormattedDateInTz(
                  importantDates.firstScanStartDate,
                  importantDates.timeZone,
                  localDataFormat,
                )} - ${getFormattedDateInTz(
                  importantDates.firstScanEndDate,
                  importantDates.timeZone,
                  localDataFormat,
                )}`
              : '-'
          }
          className={classes.fullWidth}
        />
        <InfoSection
          title="Final Scan Date Ranges"
          description={
            importantDates.lastScanStartDate &&
            importantDates.lastScanEndDate &&
            importantDates.timeZone
              ? `${getFormattedDateInTz(
                  importantDates.lastScanStartDate,
                  importantDates.timeZone,
                  localDataFormat,
                )} - ${getFormattedDateInTz(
                  importantDates.lastScanEndDate,
                  importantDates.timeZone,
                  localDataFormat,
                )}`
              : '-'
          }
          className={classes.fullWidth}
        />
      </div>
      {importantDates.timeZone && (
        <p className={classes.timeZoneInfo}>
          ***All dates are based on the host’s time zone&nbsp;
          {getTimezoneLabel(importantDates.timeZone)}. Challenge starts at midnight (12:00
          AM) and stay active until 11:59 PM on the final day.
        </p>
      )}
    </InfoBox>
  );
};

export { DetailsBlock };
